import React from 'react';

/** Suspense fallback while the lazily-loaded video bundle downloads. */
export const VideoLoading: React.FC = () => (
  <div className="w-screen h-screen flex items-center justify-center bg-[#1F2937]">
    <div className="w-14 h-14 rounded-full border-4 border-white/20 border-t-white/70 animate-spin" />
  </div>
);

export default VideoLoading;
